import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useQBStore } from '@/store/qbStore';

export const SourcePreview: React.FC = () => {
  const { files } = useQBStore();

  if (files.length === 0) {
    return (
      <Card className="h-full">
        <CardContent className="flex items-center justify-center h-full text-gray-400">
          暂无预览
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="h-full overflow-hidden flex flex-col">
      <CardHeader className="py-3 px-4 border-b">
        <CardTitle className="text-sm font-medium">原文对照</CardTitle>
      </CardHeader>
      <CardContent className="p-0 flex-1 overflow-y-auto bg-gray-100">
        <div className="flex flex-col gap-4 p-4">
          {files.map((file, idx) => (
            <div key={idx} className="bg-white p-2 rounded shadow-sm">
              {file.type.startsWith('image/') ? (
                <img 
                  src={URL.createObjectURL(file)} 
                  alt={`Preview ${idx}`} 
                  className="w-full h-auto"
                />
              ) : (
                <div className="h-32 flex items-center justify-center bg-gray-50 text-gray-500">
                  {file.name} (PDF Preview not implemented)
                </div>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
